/*
 * @format
 * @flow
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cloneDeep } from 'lodash';
import { Divider } from 'sarsaparilla';
import { STATE_READY } from '../../../../ui-lottery/src/utils/async_utils';
import { fetchAccount, enableDeveloperAccess, updateAccount } from '../../actions/account';
import { fetchOrganizations } from '../../actions/organization';
import { AccountProps } from '../../props/account';
import { ApiKeyProps } from '../../props/apiKey';
import { OrganizationProps } from '../../props/organization';
import { getState } from '../../reducers';
import { getAccount } from '../../reducers/accounts';
import { getOrganizations } from '../../reducers/organizations';
import SearchForm from './SearchForm';
import UserDisplay from '../../components/UserAdminPage/UserDisplay';
import { flattenOrgs, orgsToOptions } from '../../utils/organization';

// $FlowFixMe: this file does exist
import * as styles from './UserAdminPage.scss';

type PropTypes = {
  account: {
    account: AccountProps,
    apiKey: ApiKeyProps
  },
  organizations?: OrganizationProps[],
  states: { [key: string]: number },
  fetchOrganizations: Function,
  enableDeveloperAccess: Function,
  fetchAccount: Function,
  updateAccount: Function
};

type StateTypes = {
  account: {
    account: AccountProps,
    apiKey: ApiKeyProps
  }
};

export class UserAdminPage extends Component<PropTypes, StateTypes> {
  state = {
    account: this.props.account
  };

  componentDidMount() {
    if (this.props.states.organizations !== STATE_READY) {
      this.props.fetchOrganizations();
    }
  }

  //TODO: this state shouldn't exist! Use the prop!
  // workaround for now.
  doSetAccount = (account) => this.setState((prevState) => ({...prevState, account}));

  componentDidUpdate() {
    const { account } = this.props;
    if (account && account !== this.state.account) {
      this.doSetAccount(account);
    }
  }

  enableDeveloperAccess = () => {
    const currentAccount = cloneDeep(this.state.account);
    const { accountId, email } = this.state.account.account;

    return this.props
      .enableDeveloperAccess(accountId)
      .then(() => {
        return this.props.fetchAccount({ query: email})
      })
      .catch(() => {
        this.setState({ account: currentAccount });
      });
  };

  updateAccount = (change: ApiKeyProps) => {
    const currentAccount = cloneDeep(this.state.account);
    const apiKey = Object.assign({}, this.state.account.apiKey, change);

    this.props
      .updateAccount(apiKey)
      .then(() => {
        this.setState((prevState) => ({ ...prevState, account: { ...prevState.account, apiKey } }));
      })
      .catch(() => {
        this.setState({ account: currentAccount });
      });

    // call updateAccount API
    // create a temporary copy of state
    // merge change with local state
    // use local state for the UserDisplay component
  };

  render() {
    const { organizations, states } = this.props;
    const { account } = this.state;
    const orgOptions = orgsToOptions(flattenOrgs(organizations));
    const disabled = states.accounts !== STATE_READY; // states.accounts === STATE_UNLOADED || states.accounts ===
                                                      // STATE_LOADING;
    return (
      <div className={styles['search-page']}>
        <SearchForm />
        <Divider />
        <UserDisplay
          account={account}
          orgOptions={orgOptions}
          disabled={disabled}
          onEnable={this.enableDeveloperAccess}
          onChange={this.updateAccount} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  account: getAccount(state),
  organizations: getOrganizations(state),
  states: getState(state, 'accounts', 'organizations')
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchOrganizations,
  fetchAccount,
  enableDeveloperAccess,
  updateAccount
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAdminPage);
